export default __webpack_public_path__ + "static/media/newsletterPic.6290e45a.jpg";